import React, { memo } from 'react';
import find from 'ramda/src/find';
import isNil from 'ramda/src/isNil';
import propEq from 'ramda/src/propEq';
import Icon from '@components/@core/Icon';
import CheckIcon from '@components/@core/CheckIcon';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { CardType, LibraryAttachMenu } from '~/services/config';

const ModuleHeader = () => (
    <div className="career-required-instances">
        <div className="quotas">
            <div className="d-none d-sm-flex list py-2 desktop-screen">
                <div className="d-flex-8">
                    <div className="dsl-m12">Module</div>
                </div>
                <div className="d-flex-2">
                    <div className="dsl-m12">Type</div>
                </div>
                <div className="d-flex-3">
                    <div className="dsl-m12">Time Lock</div>
                </div>
                <div className="d-flex-2">
                    <div className="dsl-m12">Status</div>
                </div>
                <div className="d-flex-1"></div>
            </div>
        </div>
    </div>
);

function Module(props) {
    const { data, role, onMenu, edit = false, onSelect } = props;
    const dotsMenu = ['Move Up', 'Move Down', 'Remove'];
    const onClickCourse = (course, type) => {};

    return (
        <div className="lib-programs-career mt-3">
            <div className="border-bottom pt-3 mb-4">
                <ModuleHeader />
                {data.length > 0 ? (
                    <>
                        {data.map((item, index) => {
                            const name = item?.data?.en?.name || '';
                            const description = item.data.en?.description || '';
                            const thumbnail = item.data.thumb_url;
                            const type = item.card_type_id;
                            const status = item.completed_at;
                            const TYPE = find(propEq('id', type), CardType) || CardType[17];

                            return (
                                <div key={item.id || item.card_template_id || index} className="library-course-card p-0" onClick={() => onClickCourse(0, 'course')}>
                                    <div className={`lib-content d-flex ssm-column training-course ${index === 0 && 'border-0'}`} onClick={() => onMenu('preview view', item)}>
                                        <div className="module-content d-flex d-flex-1">
                                            <div className="d-flex-8 d-flex">
                                                <CheckIcon className="mr-3" size={26} checked={!isNil(status)} onClick={() => onClickCourse(0, 'course')} />
                                                <Thumbnail source={thumbnail} />
                                                <div className="d-none d-sm-block px-3">
                                                    <p className="dsl-b16 text-400 mb-0 word-break">{name}</p>
                                                    <div className="dsl-b16 w-100 truncate-one mb-0" dangerouslySetInnerHTML={{ __html: description }} />
                                                </div>
                                            </div>

                                            <div className="mobile-block d-flex-2 mt-3">
                                                <p className="dsl-b16 mb-0">
                                                    <span>Name:</span>
                                                    <span className="dsl-b16 text-400">{name}</span>
                                                </p>
                                            </div>
                                            <div className="d-flex-2">
                                                <p className="dsl-b16 mb-0">
                                                    <span className="mobile-screen">Type:</span>
                                                    <Icon name={`${TYPE.alias} me-2`} color="#676757" />
                                                    <span className="dsl-b16 text-400">{TYPE.label}</span>
                                                </p>
                                            </div>
                                            <div className="d-flex-3">
                                                <p className="dsl-b16 mb-0">
                                                    <span className="mobile-screen">Time Lock:</span> Immediately available
                                                </p>
                                            </div>
                                            <div className="d-flex-2">
                                                <p className="dsl-b16 mb-0">
                                                    <span className="mobile-screen">Status:</span> {!isNil(status) ? 'Completed' : 'Incomplete'}
                                                </p>
                                            </div>
                                            <div className="d-flex-1">{edit && <EditDropdown options={dotsMenu} onChange={(e) => onSelect(e, item)} />}</div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                ) : (
                    <p className="dsl-b16 py-4 mb-0">No Modules Attached</p>
                )}
            </div>
        </div>
    );
}

export default memo(Module);
